import moment from "moment";

export default class SafeDateTimeParser {
    static parseToMoment(input) {
        if (!input) {
            return null;
        }

        let selectedValue = null;

        if (moment.isMoment(input)) {
            selectedValue = input;
        } else {
            let parsedMoment = null;

            if (input.toString().indexOf('T') > 0) {
                // Date/Time separator, probably full format
                parsedMoment = moment(input);
            } else if (input.toString().indexOf(':') > 0) {
                // Time separator, probably time only format
                parsedMoment = moment(`2001-01-01T${input}`);
            }

            if (parsedMoment && parsedMoment.isValid()) {
                selectedValue = parsedMoment;
            }
        }

        return selectedValue;
    }
}



// WEBPACK FOOTER //
// ./src/Etc/SafeDateTimeParser.js